import type { DistributePrintRequest } from "@/api/client";
import { attemptStore } from "@/features/batches/attempts";

const print = attemptStore("cipm.print-attempt");
const serialize = (body: DistributePrintRequest) =>
  JSON.stringify([body.printer_profile_id, body.sub_batch_size ?? null, body.send ?? false]);

export const attemptKeyFor = (batchId: string, body: DistributePrintRequest) => print.keyFor(batchId, serialize(body));
export const forgetAttempt = (batchId: string) => print.forget(batchId);
